import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GmsdialogService } from './services/gmsdialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MultiStakeModalComponent } from './multi-stake-modal/multi-stake-modal.component';
import { GmsnavmenulistComponent } from './gmsnavmenulist/gmsnavmenulist.component';
import { RouterModule } from '@angular/router';
import { ConfirmedValidator } from './validators/confirmpassword.validator';
import { GmstranslatePipe } from './pipes/gmstranslate.pipe';
import { GmsAlertComponent } from './dialogs/gms-alert/gms-alert.component';
import { ConvertsymbolPipe } from './pipes/convertsymbol.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { GmsconfirmComponent } from './dialogs/gmsconfirm/gmsconfirm.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MatButtonModule } from '@angular/material/button';
import { TextsearchPipe } from './pipes/textsearch.pipe';
import { ExportComponent } from './export/export.component';
import { DateOperationsComponent } from './date-operations/date-operations.component';
import { JsonValidatorComponent } from './json-validator/json-validator.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafePipe } from './pipes/safe.pipe';
import { LabelAssetsUploadComponent } from './widgets/label-assets-upload/label-assets-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeOfTheDayComponent } from './widgets/time-of-the-day/time-of-the-day.component';
import { PrizeWheelPreviewComponent } from './previews/prize-wheel-preview/prize-wheel-preview.component';
import { WhackABingoPreviewComponent } from './previews/whack-a-bingo-preview/whack-a-bingo-preview.component';
import { WhackABingoTimerComponent } from './previews/whack-a-bingo-preview/whack-a-bingo-timer/whack-a-bingo-timer.component';
import { WhackABingoGameComponent } from './previews/whack-a-bingo-preview/whack-a-bingo-game/whack-a-bingo-game.component';
import { SortableContainerComponent } from './widgets/sortable-container/sortable-container.component';
import { PreventHtmlTagsDirective } from './directives/prevent-html-tags.directive';

@NgModule({
    declarations: [
        MultiStakeModalComponent, GmsnavmenulistComponent, GmstranslatePipe, GmsAlertComponent, ConvertsymbolPipe,
        OrderByPipe, GmsconfirmComponent, FileUploadComponent, TextsearchPipe, ExportComponent, DateOperationsComponent,
        JsonValidatorComponent, SafePipe, LabelAssetsUploadComponent, TimeOfTheDayComponent, PrizeWheelPreviewComponent,
        WhackABingoPreviewComponent, WhackABingoTimerComponent, WhackABingoGameComponent, SortableContainerComponent,
        PreventHtmlTagsDirective
    ],
    providers: [
        GmstranslatePipe, ConvertsymbolPipe, OrderByPipe, GmsdialogService, FileUploadComponent, ExportComponent,
        DateOperationsComponent, JsonValidatorComponent, NgbActiveModal, SafePipe, LabelAssetsUploadComponent,
        TimeOfTheDayComponent, PrizeWheelPreviewComponent, SortableContainerComponent, PreventHtmlTagsDirective
    ],
    imports: [
        CommonModule, MatDialogModule, RouterModule, MatButtonModule, NgxFileDropModule, NgbModule, FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule, MatDialogModule, GmsnavmenulistComponent, SafePipe, GmstranslatePipe, ConvertsymbolPipe,
        OrderByPipe, TextsearchPipe, GmsAlertComponent, GmsconfirmComponent, FileUploadComponent, LabelAssetsUploadComponent,
        TimeOfTheDayComponent, PrizeWheelPreviewComponent, SortableContainerComponent, PreventHtmlTagsDirective 
    ]
})
export class SharedModule { }
